import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, getCurrentInstance, nextTick, onBeforeUnmount, useAttrs } from 'vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import type { ModelValue } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

type DatePickerFormat = string | ((date: Date) => string) | ((dates: Date[]) => string);
/** インライン表示の設定 */
type InlineConfig = boolean | { input?: boolean };


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
  // VueDatePicker本体と同様に、Wrapperのv-modelもVue 3形式で扱う
  compatConfig: {
    MODE: 3,
  },
},
  __name: 'AppDatePicker',
  props: {
    modelValue: { default: null },
    uid: { default: undefined },
    modelType: { default: undefined },
    format: { type: [String, Function], default: undefined },
    locale: { default: undefined },
    minDate: { default: undefined },
    maxDate: { default: undefined },
    disabledDates: { type: [Array, Function], default: undefined },
    enableTimePicker: { type: Boolean, default: true },
    autoApply: { type: Boolean, default: false },
    inline: { type: [Boolean, Object], default: false },
    teleport: { type: [Boolean, String], default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



/** VueDatePickerで利用可能な日付表示形式 */
const props = __props;

const emits = __emit;

const attrs = useAttrs();
const componentUid = getCurrentInstance()?.uid;
const datePickerUid = computed(() => props.uid ?? `app-date-picker-${componentUid}`);

let focusRepairFrame: number | undefined;

/**
 * 欄外日付の選択で月が切り替わると、同じ位置のDOMが別日付として再利用されて
 * 選択日とキーボードフォーカスがずれることがあるため、選択日へフォーカスを戻す
 */
const repairSelectedDateFocus = async () => {
  if (typeof document === 'undefined') return;

  await nextTick();

  if (focusRepairFrame !== undefined) {
    window.cancelAnimationFrame(focusRepairFrame);
  }

  focusRepairFrame = window.requestAnimationFrame(() => {
    focusRepairFrame = undefined;

    const menu = document.getElementById(`dp-menu-${datePickerUid.value}`);
    const activeElement = document.activeElement;
    const selectedDates = menu?.querySelectorAll<HTMLElement>('.dp__calendar_item[aria-selected="true"]');
    const selectedDate = selectedDates?.length === 1 ? selectedDates[0] : undefined;

    if (
      selectedDate &&
      activeElement instanceof HTMLElement &&
      menu?.contains(activeElement) &&
      activeElement.classList.contains('dp__calendar_item') &&
      activeElement !== selectedDate
    ) {
      selectedDate.focus({ preventScroll: true });
    }
  });
};

onBeforeUnmount(() => {
  if (focusRepairFrame !== undefined) {
    window.cancelAnimationFrame(focusRepairFrame);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueDatePicker), _mergeProps(_unref(attrs), {
    uid: datePickerUid.value,
    "model-value": _ctx.modelValue,
    "model-type": _ctx.modelType,
    format: _ctx.format,
    locale: _ctx.locale,
    "min-date": _ctx.minDate,
    "max-date": _ctx.maxDate,
    "disabled-dates": _ctx.disabledDates,
    "enable-time-picker": _ctx.enableTimePicker,
    "auto-apply": _ctx.autoApply,
    inline: _ctx.inline,
    teleport: _ctx.teleport,
    disabled: _ctx.disabled,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emits('update:modelValue', $event))),
    onInternalModelChange: repairSelectedDateFocus
  }), _createSlots({ _: 2 }, [
    _renderList(_ctx.$slots, (_, slotName) => {
      return {
        name: slotName,
        fn: _withCtx((slotProps) => [
          _renderSlot(_ctx.$slots, slotName, _normalizeProps(_guardReactiveProps(slotProps)))
        ])
      }
    })
  ]), 1040, ["uid", "model-value", "model-type", "format", "locale", "min-date", "max-date", "disabled-dates", "enable-time-picker", "auto-apply", "inline", "teleport", "disabled"]))
}
}

})